module.exports = __webpack_public_path__ + "img/download-android.97e1da92.svg";